import React from "react";
import styled from "styled-components";
import iconOrganizacion from "./iconOrganizacion.svg"; // Asegúrate de que la ruta al icono sea correcta
import { useNavigate } from 'react-router-dom';

const NoOrganizaciones = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <IconContainer>
        <img src={iconOrganizacion} alt="No hay organizaciones" />
      </IconContainer>
      <Message>No hay ninguna organización</Message>
      <NewButton  onClick={() => navigate("/organizaciones/create-organizacion")}>NUEVA</NewButton>
    </Container>
  );
};

export default NoOrganizaciones;

// Styled components

const Container = styled.div`
  background-color: #ffffff;
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 32px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;

`;

const IconContainer = styled.div`
  width: 48px;
  height: 48px;
  img {
    width: 100%;
    height: 100%;
  }
`;

const Message = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  color: #333;
`;

const NewButton = styled.button`
  padding: 12px 24px;
  background-color: #003049;
  border: none;
  border-radius: 8px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.3s;
  &:hover {
    background-color: #002538;
  }
`;
